import React from 'react';
import { motion } from 'framer-motion';

export const ContentSection = ({ 
  title, 
  content, 
  image, 
  imagePosition = 'right',
  backgroundColor = 'white'
}) => {
  const bgColors = {
    white: 'bg-[#f9f3e2]',
    gray: 'bg-white',
    cream: 'bg-[#f9f3e2]'
  };

  return (
    <section className={`py-16 lg:py-20 ${bgColors[backgroundColor]}`}>
      <div className="container mx-auto px-4 lg:px-8">
        <div className={`grid grid-cols-1 ${image ? 'lg:grid-cols-2' : ''} gap-12 items-center`}>
          {/* Text Content */}
          <motion.div
            initial={{ opacity: 0, x: imagePosition === 'right' ? -20 : 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className={imagePosition === 'left' && image ? 'lg:order-2' : ''}
          >
            {title && (
              <h2 className="text-2xl md:text-3xl font-semibold mb-6 text-[#032925]">
                {title}
              </h2>
            )}
            <div className="prose prose-lg max-w-none">
              {typeof content === 'string' ? (
                <p className="leading-relaxed text-[#032925]/80">
                  {content}
                </p>
              ) : (
                content
              )}
            </div>
          </motion.div>

          {/* Image */}
          {image && (
            <motion.div
              initial={{ opacity: 0, x: imagePosition === 'right' ? 20 : -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              className={imagePosition === 'left' ? 'lg:order-1' : ''}
            >
              <div className="rounded-2xl overflow-hidden shadow-xl">
                <img
                  src={image}
                  alt={title || ''}
                  loading="lazy"
                  decoding="async"
                  className="w-full h-auto object-cover aspect-[4/3]"
                />
              </div>
            </motion.div>
          )}
        </div>
      </div>
    </section>
  );
};

export default ContentSection;
